import { Account } from "models/Account";
import { Person } from "models/Person";
import InvoiceRowAccount from "pages/Account/InvoiceQuoteViews/InvoiceRowAccount";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { RootStateAccount } from "storeAccount/accountStore";
import { getInvoices } from "storeAccount/actions/Billing";
import { InvoiceState } from 'storeAccount/reducers/Invoices';
import NotFoundImageQuote from "../../../assets/images/404-error.png";
import InvoicesOutstanding from "./InvoicesOutstanding";
import { useAccountTranslation } from "../translations";

interface Props {
    person: Person;
    invoiceState: InvoiceState;
    quotes: boolean;
    customer: Account;
}

interface Actions {
    getInvoices: () => void;
}

const InvoiceListOnlyFinals: React.FC<Props & Actions> = ( {
                                                               customer,
                                                               quotes,
                                                               person,
                                                               invoiceState,
                                                               getInvoices
                                                           } ) => {
    const { t } = useAccountTranslation();

    useEffect( () => {
        const refresh = () => {
            if ( document.visibilityState === 'visible' ) {
                getInvoices()
            }
        };
        document.addEventListener( "visibilitychange", refresh );
        getInvoices()
        return () => document.removeEventListener( "visibilitychange", refresh );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] )

    const accountInvoices = invoiceState.getInvoicesByAccountId( customer.id );

    if ( quotes && accountInvoices.filter( invoice => invoice.quote === true ).length <= 0 ) {
        return ( <div>
                <img src={ NotFoundImageQuote } alt={t("quotesNotFoundAlt")}
                     className="img-fluid mx-auto d-block image-not-found"></img>
                <br/>
                <p className="text-uppercase text-center" style={ { fontWeight: "lighter" } }>{t("noQuotesFound")}</p>
            </div> );
    }

    const results = accountInvoices
        .sort( ( a, b ) => ( a.IsPaid() === b.IsPaid() ) ? 0 : a.IsPaid() ? 1 : -1 )
        .sort( ( a, b ) => a.GetCreatedDate() < b.GetCreatedDate() ? 1 : -1 )
        .filter( invoice => !quotes || invoice.quote )
        .filter( invoice => quotes || !invoice.quote );

    const incomingInvoices = invoiceState.getInvoicesByCustomerId( customer.id );

    return ( <div>
            { !quotes && <>
                <InvoicesOutstanding invoices={incomingInvoices}/>
            </> }
            <div className="table-responsive">
                <table className="table table table-borderless align-middle table-centered table mb-0">
                    <tbody>
                    { results.map(invoice => <InvoiceRowAccount key={invoice.id} invoice={invoice} accountId={customer.id} />) }
                    </tbody>
                </table>
            </div>
        </div> );

};

const mapStateToProps = ( state: RootStateAccount ) => {
    return {
        invoiceState: state.Invoices
    };
};

const mapDispatchToProps = ( dispatch: any ) => {
    return bindActionCreators( { getInvoices }, dispatch );
};

export default connect( mapStateToProps, mapDispatchToProps )( InvoiceListOnlyFinals );
